import appraiser from "apis/appraiser";
import employeeApi from "apis/employee";
import * as employeeRoles from "typeConstants/employeeRoles";
import { WebApiRequest, WebApiReduxRequest, HTTP_GET, HTTP_POST, HTTP_DELETE, HTTP_PUT } from "tools/webservice";
import {
  REQUEST_APPRAISER_MANAGERS,
  RECEIVE_APPRAISER_MANAGERS,
  ERROR_APPRAISER_MANAGERS,
  REQUEST_VALUATION_COORDINATORS,
  RECEIVE_VALUATION_COORDINATORS,
  ERROR_VALUATION_COORDINATORS,
  REQUEST_VALUATION_DIRECTORS,
  RECEIVE_VALUATION_DIRECTORS,
  ERROR_VALUATION_DIRECTORS,
} from "typeConstants";
import customerService from "apis/customerService";

export const addAppraiserLicense = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: appraiser.addAppraiserLicense(),
  payload: payload,
  mountedRef: mountedRef,
  successCallback: successCallback,
});
export const updateAppraiserLicense = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: appraiser.updateAppraiserLicense(),
  payload: payload,
  mountedRef: mountedRef,
  successCallback: successCallback,
});
export const deleteAppraiserLicense = (id, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: appraiser.deleteAppraiserLicense(id),
  mountedRef: mountedRef,
  successCallback: successCallback,
  errorCallback: errorCallback
});
export const deleteAppraiserLicenseImage = (id, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: appraiser.deleteAppraiserLicenseImage(id),
  mountedRef: mountedRef,
  successCallback: successCallback,
});
export const getLicenseImage = (appraiserNumber, id, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraiser.getLicenseImage(appraiserNumber, id),
  mountedRef: mountedRef,
  successCallback: successCallback,
});

export const getAllLicenses = (appraiserNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraiser.getAllLicenses(appraiserNumber),
  mountedRef: mountedRef,
  successCallback: successCallback,
});

export const addAppraiserSignature = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: appraiser.addAppraiserSignature(payload.appraiserNumber),
  payload: payload,
  mountedRef: mountedRef,
  successCallback: successCallback,
});

export const deleteAppraiserSignature = (id, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: appraiser.deleteAppraiserSignature(id),
  mountedRef: mountedRef,
  successCallback: successCallback,
  errorCallback: errorCallback
});

export const getAppraiserSignatureExists = (appraiserNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraiser.getAppraiserSignatureExists(appraiserNumber),
  mountedRef: mountedRef,
  successCallback: successCallback,
});

export const getAppraiserManagers = () => WebApiReduxRequest(REQUEST_APPRAISER_MANAGERS, RECEIVE_APPRAISER_MANAGERS, ERROR_APPRAISER_MANAGERS, HTTP_GET, employeeApi.getManagersByEmployeeRoles([employeeRoles.VALUATION_APPRAISER]));
export const getValuationCoordinators = () => WebApiReduxRequest(REQUEST_VALUATION_COORDINATORS, RECEIVE_VALUATION_COORDINATORS, ERROR_VALUATION_COORDINATORS, HTTP_GET, employeeApi.getEmployeesByRoles([employeeRoles.VALUATION_QUALITY_ASSOCIATE]));
export const getValuationDirectors = () => WebApiReduxRequest(REQUEST_VALUATION_DIRECTORS, RECEIVE_VALUATION_DIRECTORS, ERROR_VALUATION_DIRECTORS, HTTP_GET, employeeApi.getManagersByEmployeeRoles([employeeRoles.VALUATION_QUALITY_ASSOCIATE]));

export const getAppraiserRejections = (controlIdNumber, mountedRef, successCallback) => WebApiRequest({
  method: HTTP_GET,
  endpoint: customerService.getAppraiserRejections(controlIdNumber),
  mountedRef: mountedRef,
  successCallback: successCallback,
});
export const addAppraiserRejections = (controlIdNumber, request, mountedRef, successCallback) => WebApiRequest({
  method: HTTP_POST,
  payload: request,
  endpoint: customerService.addAppraiserRejections(controlIdNumber),
  mountedRef: mountedRef,
  successCallback: successCallback,
});